module.exports = __webpack_public_path__ + "static/media/icon-received-000.26341fb7.svg";